<template>
  <div>
    <Header />
    <router-view keep-alive />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
  },
};
</script>
